import React from "react";
import { useI18n } from "@/contexts/I18nContext";

/**
 * Batch 2 · 2.6 (R57) — the one data source behind the figures on this page:
 * "Main GL" when a general ledger is loaded, otherwise "Trial Balance upload".
 * Reads the `source` field every figure endpoint now returns.
 */
export default function SourceBadge({ source, className = "" }) {
  const { t } = useI18n();
  if (!source) return null;
  const label = source === "gl" ? t("analytics.sourceGl")
    : source === "tb" ? t("analytics.sourceTb")
    : t("analytics.sourceNone");
  const tone = source === "gl" ? "bg-emerald-50 text-emerald-800 border-emerald-200"
    : source === "tb" ? "bg-amber-50 text-amber-800 border-amber-200"
    : "bg-slate-100 text-slate-600 border-slate-200";
  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs ${tone} ${className}`}
          data-testid="source-badge" title={t("analytics.sourceLabel")}>
      {t("analytics.sourceLabel")}: {label}
    </span>
  );
}
